module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_6000.0f7149d2.png";